import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { FileText, Download } from "lucide-react";

function fmtSize(n) {
  if (!n) return "";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export default function FileCard({ path, className = "" }) {
  const [meta, setMeta] = useState(null);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    if (!path) return;
    let cancelled = false;
    api.get(`/files-meta/${path}`)
      .then((r) => { if (!cancelled) setMeta(r.data); })
      .catch((e) => { console.error("file meta failed", e); });
    return () => { cancelled = true; };
  }, [path]);

  const download = async () => {
    setDownloading(true);
    try {
      const r = await api.get(`/files/${path}`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = meta?.filename || "download";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } finally { setDownloading(false); }
  };

  return (
    <div className={`jj-card !rounded-xl p-4 flex items-center gap-3 ${className}`} data-testid={`file-card-${path}`}>
      <div className="h-10 w-10 rounded-lg bg-cream-surface flex items-center justify-center shrink-0">
        <FileText className="h-5 w-5 text-burgundy" strokeWidth={1.5} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm text-jjblue truncate">{meta?.filename || "Document"}</div>
        <div className="text-xs text-[var(--jj-muted)]">
          {meta?.content_type || "file"} · {fmtSize(meta?.size)}
        </div>
      </div>
      <button onClick={download} disabled={downloading}
        className="btn-secondary !py-1.5 !px-3 text-xs flex items-center gap-1.5"
        data-testid={`file-download-${path}`}>
        <Download className="h-3.5 w-3.5" strokeWidth={1.6} /> {downloading ? "…" : "Open"}
      </button>
    </div>
  );
}
